// Connexion, inscription, déconnexion ; rôle et droits (le serveur fait foi, ici on cache ce qu'on ne peut pas faire).
window.actions.login = function() {
    var email = document.getElementById('auth-email').value.trim();
    var pwd = document.getElementById('auth-pwd').value.trim();
    if(!email || !pwd) { window.state.authError = "Remplissez tous les champs"; window.renderApp(); return; }
    window.syncWithServer('login', {email: email, password: pwd}, function(res) {
        if(res.success) { if (window.connexionReussie) window.connexionReussie(email); window.location.reload(); }
        else { window.state.authError = res.message || "Erreur"; window.renderApp(); }
    });
};
window.actions.register = function() {
    var email = document.getElementById('auth-email').value.trim();
    var pwd = document.getElementById('auth-pwd').value.trim();
    if(!email || !pwd) { window.state.authError = "Remplissez tous les champs"; window.renderApp(); return; }
    if(pwd.length < 8) { window.state.authError = "Mot de passe : 8 caractères minimum"; window.renderApp(); return; }
    window.syncWithServer('register', {email: email, password: pwd}, function(res) {
        if(res.success) { if (window.connexionReussie) window.connexionReussie(email); window.location.reload(); }
        else { window.state.authError = res.message || "Erreur"; window.renderApp(); }
    });
};
window.actions.logout = function() {
    window.syncWithServer('logout', {}, function() { window.location.reload(); });
};
// Fenêtre du calendrier : on n'ajoute des jours que sur demande, pour ne pas payer le dessin de tout le semestre.
// Le calendrier ne dessine qu'une fenêtre de jours ; les décalages (pause, déplacement, lissage…) portent sur
// window.state.tasks, c'est-à-dire sur TOUT le planning, jours affichés ou non.

// --- RÔLES CÔTÉ NAVIGATEUR ---------------------------------------------------------------------------------------
// Le serveur fait foi (chaque action vérifie le rôle et l'abonnement) ; ici on ne fait que cacher ce qu'on ne peut
// pas faire, pour ne pas proposer des boutons qui finiraient en « refusé ».
window.estAdmin = function() { return !!(window.state.user && window.state.user.admin); };
window.peutIA = function() { return !!(window.state.user && (window.state.user.admin || window.state.user.ia)); };
window.chargerMoi = function(cb) {
    // Harnais de tests : administrateur d'emblée, sans attendre la réponse simulée (sinon une fenêtre ouverte trop tôt cache ses boutons).
    if (window.__spaTest && !window.state.user.email) window.state.user = { role: 'admin', email: 'test@exemple.fr', admin: true, ia: true, abonnement: null };
    window.syncWithServer('me', {}, function(d) {
        // Harnais de tests (window.__spaTest) : une réponse simulée sans rôle vaut « administrateur », comme avant les rôles.
        if (window.__spaTest && d && d.success && !('role' in d)) d = { success: true, role: 'admin', admin: true, ia: true, email: d.email || 'test@exemple.fr' };
        if (d && d.success) {
            window.state.user = { role: d.role || 'user', email: d.email || '', admin: !!d.admin, ia: !!d.ia, abonnement: d.abonnement || null };
            window.renderHeader(); window.renderPlanningBar(); window.renderContentBientot();
        }
        if (cb) cb(d);
    });
};
window.actions.ouvrirAbonnement = function() { window.actions.switchTab('abonnement'); };

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const estAdmin = window.estAdmin;
export const peutIA = window.peutIA;
export const chargerMoi = window.chargerMoi;
